import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';

@withRouter
@inject("store")

export default class Introduce extends Component
{
    render()
    {
        return <div className="introduce">
              <div className ="introstart">
             <img src={cookie} className="cookiepicture" alt="cookie" />
             <div className ="introtext">这是小说研究所的向导APP,面向没有太多写作经验的人群。<br/><br/>
                 如果你一直想写小说,却无从下手
                 那这个APP就最适合你了。<br/>
                 而小说研究所在公众号“过雨红素”里。
                 如果在使用完本APP之后，想了解更多写作理论，可以再去看小说研究所。
                 </div></div>

                 <div className = "asktext">现在，要问一个最重要的问题：<br/>你写过小说吗？</div>
                <div className="buttonbox">
                <Link to="/story"><Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.props.store.whynowrite= "nothing"}  >从来没写过完整的小说</Button></Link><br/>
                 <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.props.history.push("/improve")} >写过一些，但不太满意</Button><br/>
                 <Link to="/"><Button icon="arrow-right" className="Button" minimal={true}  >以后再说，我要回刚刚的页面</Button></Link>
                </div>
                
             </div>;
    }
} 